import * as React from "react";
const SvgFiRrWatermelon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-watermelon_svg__a)">
      <path
        fill="#062147"
        d="M22.373 2.324a4.335 4.335 0 0 0-6.874-1.05L1.273 15.5a4.35 4.35 0 0 0-1.214 3.742c.718 3.917 5.816 4.606 9.038 4.765 10.878.156 18.423-11.957 13.276-21.683m-4.158 15.892a12.87 12.87 0 0 1-14.983 2.377 2.322 2.322 0 0 1-.545-3.682L16.91 2.686a2.322 2.322 0 0 1 3.683.546 12.87 12.87 0 0 1-2.378 14.984m.4-10.448a1.308 1.308 0 1 1-1.85 1.85 5.4 5.4 0 0 1-.75-1.966.526.526 0 0 1 .634-.635c.698.12 1.365.375 1.964.751zm-5 8a1.309 1.309 0 0 1-1.848 1.85 5.4 5.4 0 0 1-.752-1.967.526.526 0 0 1 .634-.634 5.4 5.4 0 0 1 1.967.748zm3-3a1.308 1.308 0 1 1-1.85 1.85 5.4 5.4 0 0 1-.75-1.966.526.526 0 0 1 .634-.635 5.4 5.4 0 0 1 1.966.75zm-8 4a1.308 1.308 0 0 1-1.848 1.85 5.4 5.4 0 0 1-.751-1.967.526.526 0 0 1 .634-.635 5.4 5.4 0 0 1 1.968.75z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-watermelon_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrWatermelon;
